import React, { useMemo } from "react";
import _ from "lodash";

import classNames from './style.module.scss';

import CustomSection from "../../custom-general/custom-section";
import ExecutiveSummary from "../../custom-visual-inspection/executive-summary";
import GeneralInformation from "../../custom-drt/generalInformation";
import PDFTablePage from "../../../themed/pdf/pdfTablePage";

import { PDRTItem } from "../pdrtReportItems";
import { getSinglePDRTSummary } from "../pdrt-data-page";
import { getReadingStyle, getResultItemStyle, getUTMColorCodes } from "../../../../utils/data";
import { Column } from "../../../../utils/models";
import { getChunkedData } from "../../../../utils/utilities";

interface Props {
    summary: string;
    items: PDRTItem[];
}

const PDRTDataSummary: React.FC<Props> = ({ summary, items }) => {
    const data = useMemo(() => {
        const pdrtItems =  items.map((item) => getSinglePDRTSummary(item));
		return _.orderBy(pdrtItems, ['srNo'], ['asc']);
    }, [items]);

	const generalInfoItems = useMemo(() => {
		return items.map((item) => ({
			id: item.id,
			source: item.source,
			sourceActivity: item.sourceActivity,
			sourceManufacturer: item.sourceManufacturer,
			sourceSize: item.sourceSize,
			contrastUsed: item.contrastUsed,
			equipmentSerialNumber: item.sourceSerialNumber,
			imageFilmType: item.imageFilmType,
			drtScannerCalibrationDate: item.drtScannerCalibrationDate,
			sourceConformityInspectionDate: item.sourceConformityInspectionDate,
			pipeSpecification: item.materialSpecification,
			serialNumber: item.drtScannerSerialNumber,
			drtScannerModalName: item.drtScannerName,
			pipeMaterialClass: 'N/A',
		}))
	}, [items]);

    return ( 
		<>
			<ExecutiveSummary summary={summary} />

			<GeneralInformation reportItems={generalInfoItems} />
			
			{getChunkedData(data, 20).map((chunk, index) => (
				<CustomSection key={index} sectionTitle="Summary">
					<div  className={classNames.executiveSummaryTable}>
						<PDFTablePage data={chunk} columns={columns} />
					</div>
				</CustomSection>
			))}
		</>
     );
};

const columns: Column[] = [
	{
		path: 'srNo',
		label: 'Sr. No.',
	},
	{
		path: 'location',
		label: 'Location',
	},
	{
		path: 'zoneNumber',
		label: 'Zone Number',
	},
	{
		path: 'scanNumber',
		label: 'Scan Number',
	},
	{
		path: 'nominalThickness',
		label: 'Nominal Thickness (mm)',
	},
	{
		path: 'corrosionAllowance',
		label: 'Corrosion Allowance (mm)',
	},
	{
		path: 'thickness',
		label: 'Measured Thickness (mm)',
	},
	{
		path: 'wallLoss',
		label: 'Wall Loss (mm)',
		style: (item: PDRTItem) => getReadingStyle(+item.nominalThickness, +item.corrosionAllowance as number, item.thickness, getUTMColorCodes()) as React.CSSProperties
	},
	{
		path: 'wallLossPercentage',
		label: '% Loss',
		style: (item: PDRTItem) => getReadingStyle(+item.nominalThickness, +item.corrosionAllowance as number, item.thickness, getUTMColorCodes()) as React.CSSProperties
	},
	{
		path: 'result',
		label: 'Result',
		style: (item: any) => getResultItemStyle(item),
	},
	{
		path: 'remark',
		label: 'Remark',
	},
];
 
export default PDRTDataSummary;